import { useMemo } from 'react';
import { Checkbox } from '@rsos/base-components';
import type { IarAgency } from '@rsos/reduxDataStore/src/features/eventShare/types';
import type { IarSelectedMember } from './helpers';
import {
  buildSelection,
  matchesSearch,
  useResolvedMembers,
} from './iarAgencySelectorHelpers';

interface AgencyCheckboxProps {
  org: string;
  agency: IarAgency;
  selectedCount: number;
  onToggle: (agency: IarAgency, visibleSelections: IarSelectedMember[]) => void;
  searchTerm: string;
}

/** Agency checkbox — selects/deselects only the visible (filtered) members. */
const AgencyCheckbox = ({
  org,
  agency,
  selectedCount,
  onToggle,
  searchTerm,
}: AgencyCheckboxProps) => {
  const { data: members } = useResolvedMembers(org, agency.legacyId);

  const visibleSelections = useMemo(() => {
    const visibleMembers = searchTerm
      ? (members ?? []).filter(m => matchesSearch(m, searchTerm))
      : (members ?? []);
    return visibleMembers.map(m => buildSelection(m, agency));
  }, [members, searchTerm, agency]);

  const allSelected =
    visibleSelections.length > 0 && selectedCount === visibleSelections.length;

  return (
    <Checkbox
      label={agency.name}
      isChecked={allSelected}
      onChange={() => onToggle(agency, visibleSelections)}
      checkboxID={`iar-agency-${agency.legacyId}`}
    />
  );
};

export default AgencyCheckbox;
